<div
  [class]="getElementClasses()"
  class="text-md font-bold mb-4"
  [style.text-align]="widget.textAlign || 'left'"
  [innerHTML]="widget.title"
></div>
